const memberBaseUrl = 'https://www.sentarahealthplans.com';
const qa_base_url = 'https://webapidevqa.sentara.com/qa4'
const azureBaseURL = process.env.REACT_APP_BASE_URL?.includes('/qa5')
  ? qa_base_url
  : process.env.REACT_APP_BASE_URL;

// Exported utility functions for Spanish language support
export const isSpanishLanguage = (language?: string): boolean => {
  return language?.toLowerCase().startsWith('es') ?? false;
};

export const getActiveLanguage = (): string | undefined => {
  if (typeof globalThis.window === 'undefined') {
    return undefined;
  }

  const savedLanguage = globalThis.window.localStorage?.getItem('userLanguagePreference');
  return savedLanguage || globalThis.window.navigator?.language;
};

export const getLocalizedUrl = (baseUrl: string): string => {
  const activeLanguage = getActiveLanguage();
  const isSpanish = isSpanishLanguage(activeLanguage);
  return isSpanish
    ? `${baseUrl}/es-US`
    : `${baseUrl}/en`;
};

const getLocalizedMemberBaseUrl = (): string => {
  return getLocalizedUrl(memberBaseUrl);
};

export type SsoUrls = {
  chooseHealthyURL?: string;
  healthSavingAccounts?: string;
  PayMonthlyPremium?: string;
  fitnessURL: string;
  formerAvmedMember: string;
  claimsLinkUrl: string;
  HCSEmployeeHealthWellnessURL: string;
  PRIMARY_CARE_URL: string;
  LAB_SERVICES_URL: string;
  PHYSICAL_THERAPY_URL: string;
  SPECIALTY_PHARMAC_URL: string;
  authorizationsLinkUrl: string;
  scheduleLabWorkUrl: string;
  memberLogin: string;
  paySentaraBillSignInURL: string;
  pharmacyReimbursement: string;
  preAuthorization: string;
  prescriptionDrugs: string;
  expressScript: string;
  contactUs: string;
  hingeHealthURL?: string;
  rxSavingsURL?: string;
  benefitFocusSSOUrl: string;
  launchDarklyURL: string;
  memberHome: string;
  smartShopperURL?: string;
  sentaraHealthPlans: string;
  sentaraHealthPlansURL: string;
  manageRenewPolicy?: string;
  termAndCondition: string;
  languagesAssistance: string;
  footerNoticeOfNonDiscrimination: string;
  accessibility: string;
  wellnessToolsURL: string;
  selfPacedProgramsURL: string;
  healthyOnDemandURL: string;
  exclusiveDiscountsURL: string;
  diabetesPreventionURL: string;
  SENTARA_URL: string;
  VIRGINIA_BEACH_URL: string;
  VirtualVisitSSO?: string;
  virtualVisitUrl?: string;
  PersonalHealthRecord?: string;
  PersonalHealthAssessment?: string;
  WellnessTools?: string;
  HealthReimbursementAccount?: string;
  findDoctor?: string;
  UrgentCareSearch?: string;
  HSQCalculateTreatmentCostUrl: string;
  CalculateTreatmentCostUrl?: string;
  ChangePrimaryCare?: string;
  ViewCarePlan?: string;
  DentalDominion?: string;
  VisionCare?: string;
  TravelAssistance?: string;
  PharmacyResources?: string;
  PharmacyOptum?: string;
  PRESCRIPTION_DELIVERY_URL?: string;
  vlocityEnrollBenefits?: string;
  BehavioralHealthProvider?: string;
  FAQs?: string;
  claimAppealForm?: string;
  medicareAddressChangeUrl?: string;
  medicaidAddressChangeUrl?: string;
  individualOnAddressChangeUrl?: string;
  alternativeAddressForm?: string;
  childOnlyPlanUrl?: string;
  employeeAssistanceProgram?: string;
};
export const DEFAULT_SSO_URLS_BASE: SsoUrls = {
  fitnessURL: 'https://www.activeandfitdirect.com',
  formerAvmedMember: 'https://secure-web.cisco.com/19p24qDgoFRS2t4YL538-VBCfwgFgvaDJreyc4ZW1bO_lLzySpPGtpD5xu3rz2PUZYnFA3uR3o1G_IACKCUc-hH5ej4z4khijqr8d_nZUw0H-eSqkCmg5iZ1ZOTTfLlWRYf_SAL-wERjiFa1DIx27bv9-wLYAHpT_-O95JHvkj3uoDbxLEUqcvFVI0_TuDdmQqxG1pwMSsHwe72l7oFV3ElirFswiTn01mDvwMeqVV1gO99tatd0lzsb-bTBbVltoaduE0Q5x6YFfJhrtm_mtmgRo0nYAEMprSvDwOfMGW5XpD9NCvRB6N_0EdhDqpMmZ/https%3A%2F%2Fmyhistory.avmed.org%2F',
  claimsLinkUrl:
    'https://sit1-consumerism-avmed.dxp.nttdataservices.com/en/member?Claims=Claims',
  HCSEmployeeHealthWellnessURL: 'https://www.careatc.com/patients',
  PRIMARY_CARE_URL:
    'https://www.sentara.com/hospitalslocations/sentara-virtual-care/our-care-teams/primary-care',
  LAB_SERVICES_URL:
    'https://www.sentara.com/medicalservices/laboratory-services/laboratory-scheduling?step=map',
  PHYSICAL_THERAPY_URL:
    ' https://www.sentara.com/hospitalslocations/sentara-virtual-care/our-care-teams/physical-therapy',
  SPECIALTY_PHARMAC_URL:
    'https://www.sentarahealthplans.com/members/manage-plans/specialty-pharmacy-information',
  authorizationsLinkUrl:
    'https://sit1-consumerism-avmed.dxp.nttdataservices.com/en/member?Authorizations=Authorizations',
  scheduleLabWorkUrl: 'https://myquest.questdiagnostics.com/web/home',
  memberLogin: memberBaseUrl + '/signin',
  paySentaraBillSignInURL: 'https://www.sentara.com/billing',
  pharmacyReimbursement:
    'https://shc-p-001.sitecorecontenthub.cloud/api/public/content/d3b69842d8d745f3a576e79813299b45?v=86f62ffd',
  preAuthorization:
    'https://sentara-223793.workflowcloud.com/forms/f9b89aaf-bdc1-4e42-b942-ab907160b4c2',
  prescriptionDrugs:
    'https://www.sentarahealthplans.com/members/manage-plans/prescription-drug-lists',
  expressScript:
    'https://www.express-scripts.com/frontend/open-enrollment/shpcomm',
  contactUs: memberBaseUrl + '/company/about/contact-sentara-health-plans',
  benefitFocusSSOUrl: 'BenefitFocusSSOUrl',
  launchDarklyURL: 'https://app.launchdarkly.com/sdk/evalx/',
  memberHome: memberBaseUrl + '/members/',
  sentaraHealthPlans: 'https://www.sentarahealthplans.com/members',
  sentaraHealthPlansURL: 'https://www.sentarahealthplans.com/signin',
  termAndCondition:
    memberBaseUrl + '/company/policies/terms-of-use-and-disclaimer',
  languagesAssistance: memberBaseUrl + '/company/policies/language-assistance',
  footerNoticeOfNonDiscrimination:
    memberBaseUrl + '/notice-of-nondiscrimination',
  accessibility: '#',
  wellnessToolsURL:
    'https://www.webmdhealth.com/SentaraHealthPlans/connect.aspx',
  selfPacedProgramsURL:
    'https://www.sentarahealthplans.com/en/members/health-and-wellness/prevention-and-wellness/wellbeing-programs',
  healthyOnDemandURL:
    'https://www.sentarahealthplans.com/en/members/health-and-wellness/videos',
  exclusiveDiscountsURL: 'https://marketplace.huskwellness.com/',
  diabetesPreventionURL: 'https://go.omadahealth.com/sentara',
  SENTARA_URL:
    'https://sentaraeap.personaladvantage.com/welcome?scheme=hashcode&o=SENTARA&target=/',
  VIRGINIA_BEACH_URL:
    'https://sentaraeap.personaladvantage.com/welcome?scheme=hashcode&o=VIRGINIABEACH&target=/',
  PersonalHealthRecord: 'WellnessToolSSOUrl?source=phr',
  PersonalHealthAssessment: 'WellnessToolSSOUrl?source=pha',
  WellnessTools: 'WellnessToolSSOUrl?source=wellness',
  HealthReimbursementAccount: 'ChoiceStrategiesSSOUrl',
  findDoctor: 'HelathSparqOneSSOUrl',
  UrgentCareSearch: 'HelathSparqOneSSOUrl',
  HSQCalculateTreatmentCostUrl: 'HealthSparqOne/CalculateTreatmentCostUrl',
  ChangePrimaryCare: 'HelathSparqOneSSOUrl',
  ViewCarePlan: 'JivaSSOUrl',
  VisionCare: 'VisionCareSSOUrl',
  TravelAssistance: 'AssistAmerica',
  PharmacyResources: 'EsiRx?source=orderrx',
  PharmacyOptum: 'OptumRx',
  PRESCRIPTION_DELIVERY_URL:
    'https://www.sentarahealthplans.com/members/manage-plans/prescription-home-delivery',
  vlocityEnrollBenefits: 'Vlocity/EnrollBenefits',
  FAQs: memberBaseUrl + '/en/members/frequently-asked-questions',
  claimAppealForm: 'https://shc-p-001.sitecorecontenthub.cloud/api/public/content/Member_Appeals_Packet?v=c69d185a',
  medicareAddressChangeUrl: 'https://www.ssa.gov/personal-record/update-contact-information',
  medicaidAddressChangeUrl: 'https://coverva.dmas.virginia.gov/',
  childOnlyPlanUrl: 'https://shc-p-001.sitecorecontenthub.cloud/api/public/content/AvMed-Authorization-for-Authorized-Representative.pdf?v=3cba2d3a'
};

export const PROD_SSO_URLS: Partial<SsoUrls> = {
  claimsLinkUrl: 'https://myhub.avmed.org/en/member?Claims=Claims',
  authorizationsLinkUrl: 'https://myhub.avmed.org/en/member?Authorizations=Authorizations'
};

const getEnvironmentSpecificUrls = (env?: string): SsoUrls => {
  const isProd = env?.toLowerCase() === 'prod' || env?.toLowerCase() === 'production';
  const localizedMemberBaseUrl = getLocalizedMemberBaseUrl();
  const isSpanish = isSpanishLanguage(getActiveLanguage());

  return {
    ...DEFAULT_SSO_URLS_BASE,
    memberLogin: localizedMemberBaseUrl + '/signin',
    contactUs: localizedMemberBaseUrl + '/members/contact-us',
    memberHome: localizedMemberBaseUrl + '/members/',
    termAndCondition:
      localizedMemberBaseUrl + '/company/policies/terms-of-use-and-disclaimer',
    languagesAssistance:
      localizedMemberBaseUrl + '/company/policies/language-assistance',
    footerNoticeOfNonDiscrimination:
      localizedMemberBaseUrl + '/notice-of-nondiscrimination',
    FAQs: isSpanish
      ? localizedMemberBaseUrl + '/members/frequently-asked-questions'
      : memberBaseUrl + '/en/members/frequently-asked-questions',
    ...(isProd && PROD_SSO_URLS)
  };

};

export const DEFAULT_SSO_URLS = (env?: string): SsoUrls => {
  return getEnvironmentSpecificUrls(env);
};